import { BaseChat } from './BaseChat';
import { MEPSDKType } from './types';
import { reportException } from 'src/exceptionReporting';

export class LiveChat extends BaseChat {
  constructor(
    mepsdk: MEPSDKType,
    domain: string,
    token: string,
    containerId: string,
  ) {
    super(mepsdk, domain, containerId);
    this.initialize(token);
  }

  private initialize(token: string) {
    try {
      super.setup(token);
    } catch (error) {
      console.error('Failed to setup LiveChat:', error);
      reportException('MoxoTokenInitializeError', error);
      throw error
    }
  }

  launch(channelId: number) {
    try {
      this.mepsdk.openClientLiveChatWithChannelID(
        channelId.toString(), // Convert channelId to string
        this.containerId,
      );
    } catch (error) {
      console.error('Failed to launch LiveChat:', error);
      throw error; // Optionally re-throw if needed
    }
  }
}